export const getVehicleRejectionContext = (vehicle) => {
  if (!vehicle) {
    return {
      agencyName: '[Nom de l\'Agence]',
      brand: '[Marque]',
      model: '[Modèle]',
      year: '[Année]',
      plate: '[Matricule]',
    };
  }

  return {
    agencyName:
      vehicle.owner?.vendorDetails?.companyName || vehicle.owner?.fullName || '[Nom de l\'Agence]',
    brand: vehicle.specs?.brand?.name || '[Marque]',
    model: vehicle.displayModelName || vehicle.specs?.model?.name || vehicle.customModelName || '[Modèle]',
    year: vehicle.specs?.year || '[Année]',
    plate: vehicle.licencePlateNumber || '[Matricule]',
  };
};

export const fillRejectionTemplate = (template, vehicle) => {
  if (!template) return '';
  const ctx = getVehicleRejectionContext(vehicle);
  const replacements = {
    '{{agencyName}}': ctx.agencyName,
    '{{agency}}': ctx.agencyName,
    '{{brand}}': String(ctx.brand),
    '{{marque}}': String(ctx.brand),
    '{{model}}': String(ctx.model),
    '{{modele}}': String(ctx.model),
    '{{year}}': String(ctx.year),
    '{{annee}}': String(ctx.year),
    '{{plate}}': String(ctx.plate),
    '{{licencePlate}}': String(ctx.plate),
    '{{matricule}}': String(ctx.plate),
    '{{title}}': '[Préciser le motif]',
    '{{reason}}': '[Préciser le motif]',
    '[Nom de l\'Agence]': ctx.agencyName,
    '[Marque]': String(ctx.brand),
    '[Modèle]': String(ctx.model),
    '[Année]': String(ctx.year),
    '[Matricule]': String(ctx.plate),
  };

  let text = String(template);
  Object.entries(replacements).forEach(([token, value]) => {
    text = text.split(token).join(value);
  });
  return text;
};

export const DEFAULT_REJECTION_TEMPLATE = `Bonjour {{agencyName}},

Merci d'avoir soumis votre véhicule {{brand}} {{model}} ({{year}} sous le matricule {{plate}}) sur la plateforme Carvy.

Après analyse par notre équipe de conformité, nous ne pouvons pas valider ce véhicule pour le moment car il ne respecte pas certains de nos critères de qualité.

Motif du refus : 👉 {{title}}

Comment corriger cela ? Nous vous invitons à vous connecter à votre espace Agence, cliquer sur "Modifier" sur le véhicule concerné, corriger le point mentionné ci-dessus, et soumettre à nouveau la demande.

Si vous avez des questions, notre équipe support est à votre disposition.

Cordialement, L'équipe de Validation Carvy`;

export const buildRejectionMessageFromReason = (reason, vehicle) => {
  if (!reason?.template) return fillRejectionTemplate(DEFAULT_REJECTION_TEMPLATE, vehicle);
  const withTitle = String(reason.template)
    .split('{{title}}')
    .join(reason.title || '')
    .split('{{reason}}')
    .join(reason.title || '');
  return fillRejectionTemplate(withTitle, vehicle);
};
